import { useEffect, useState, useRef } from 'react'
import { motion } from 'framer-motion'

export function CustomCursor() {
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const [isHovering, setIsHovering] = useState(false)
  const [isVisible, setIsVisible] = useState(false)
  const positionRef = useRef(position)

  useEffect(() => {
    positionRef.current = position
  }, [position])

  useEffect(() => {
    const updatePosition = (e: MouseEvent) => {
      setPosition({ x: e.clientX, y: e.clientY })
      if (!isVisible) setIsVisible(true)
    }

    window.addEventListener('mousemove', updatePosition)

    const checkElement = () => {
      const pos = positionRef.current
      const el = document.elementFromPoint(pos.x, pos.y)
      if (el && el.closest('a, button, [role="button"]')) {
        setIsHovering(true)
      } else {
        setIsHovering(false)
      }
    }

    const intervalId = setInterval(checkElement, 50)

    return () => {
      window.removeEventListener('mousemove', updatePosition)
      clearInterval(intervalId)
    }
  }, [isVisible])

  if (typeof navigator !== 'undefined' && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return null
  }

  return (
    <motion.div
      className="fixed top-0 left-0 w-6 h-6 rounded-full border-2 border-[#f75e47] pointer-events-none z-[99999] mix-blend-difference hidden md:block"
      animate={{
        x: position.x - 12,
        y: position.y - 12,
        scale: isHovering ? 2.5 : 1,
        borderColor: isHovering ? '#ff8a7a' : '#f75e47',
        backgroundColor: isHovering ? 'rgba(247, 94, 71, 0.2)' : 'transparent',
      }}
      transition={{
        type: "spring",
        stiffness: 400,
        damping: 28,
        mass: 0.5
      }}
    >
      {isHovering && (
        <motion.div
          className="absolute inset-0 rounded-full bg-[#f75e47] opacity-20"
          animate={{ scale: [1, 1.2, 1] }}
          transition={{ repeat: Infinity, duration: 1 }}
        />
      )}
    </motion.div>
  )
}
